import * as React from 'react';
import { IBac } from '../models';
import { useData } from '../core/context/ProvidersContext';

export function useBacs(): {
  bacs: IBac[];
  loading: boolean;
  error: string | null;
  refresh: () => void;
} {
  const data = useData();
  const [bacs, setBacs] = React.useState<IBac[]>([]);
  const [loading, setLoading] = React.useState(true);
  const [error, setError] = React.useState<string | null>(null);

  const refresh = React.useCallback(() => {
    setLoading(true);
    setError(null);
    data.getBacs()
      .then(setBacs)
      .catch((err: Error) => setError(err.message))
      .finally(() => setLoading(false));
  }, [data]);

  React.useEffect(() => { refresh(); }, [refresh]);

  return { bacs, loading, error, refresh };
}
